export { default as FavoriteCard } from './favorite-card';
